import { assertNotEmpty } from '@festina-life/core'
import { Alert, FullscreenSpinner } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Stack } from '@festina-life/ui/structure'
import { useMemo } from 'react'

import { useIsInlineEditingAvailable } from '../../hooks/useIsInlineEditingAvailable'
import { useRegisteredTenant } from '../../system/useRegisteredTenant'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { useOperationsContext } from '../../workspace/operationsContext'
import { TenantViewerTopBar } from './TenantViewerTopBar'
import { UpdateRegisteredTenantForm } from './UpdateRegisteredTenantForm'

export const TenantViewer = () => {
  const currentTenantRegistrationId = useRegisteredTenant()
  const isInlineEditingAvailable = useIsInlineEditingAvailable()
  const { isLoading } = useOperationsContext()

  assertNotEmpty(currentTenantRegistrationId)

  const translate = useTranslate()
  const { applicationRegisteredTenants: registeredTenants } =
    useApplicationViewOperationsContext()
  const registeredTenantOperation = useMemo(
    () =>
      registeredTenants.find(
        (operation) =>
          operation.internalOperation.registeredTenant?.tenantId ===
          currentTenantRegistrationId,
      ),
    [currentTenantRegistrationId, registeredTenants],
  )

  if (isLoading) {
    return <FullscreenSpinner position="relative" />
  }

  if (!registeredTenantOperation?.internalOperation.registeredTenant) {
    return null
  }

  return (
    <div className="grid size-full grid-rows-[auto_1fr] overflow-hidden">
      <TenantViewerTopBar />
      <Stack className="flex flex-col gap-y-2 p-2">
        <Alert
          severity="info"
          title={
            registeredTenantOperation.isDraft
              ? translate('tenantViewer.info.draft', {
                  registeredTenantId: currentTenantRegistrationId,
                  name:
                    registeredTenantOperation.internalOperation.registeredTenant
                      .tenantName ?? '-',
                })
              : translate('tenantViewer.info.branch', {
                  registeredTenantId: currentTenantRegistrationId,
                  name:
                    registeredTenantOperation.internalOperation.registeredTenant
                      .tenantName ?? '-',
                })
          }
          className="max-w-full!"
        />
        {isInlineEditingAvailable && (
          <UpdateRegisteredTenantForm operation={registeredTenantOperation} />
        )}
      </Stack>
    </div>
  )
}
